"use client";

import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { WebSocketProvider } from "@/contexts/websocket-context";
import { FeatureFlagProvider } from "@/contexts/FeatureFlagContext";
import { DemoModeProvider } from "@/contexts/DemoModeContext";
import { MockDataProvider } from "@/contexts/mock-data-context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { LayoutProvider } from "@/contexts/LayoutContext";
import { ModalProvider } from "@/contexts/ModalContext";
import { SessionManager } from "@/components/SessionManager/SessionManager";
import ClientBootstrap from "@/components/bootstrap/bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FloorSelectionProvider } from "@/contexts/FloorSelectionContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { SmplrProvider } from "@/contexts/SmplrContext";
import { FloorplanDeviceStateProvider } from "@/contexts/FloorplanDeviceStateContext";
import { DaylightUnitProvider } from "@/contexts/DaylightUnitContext";
import { LoadingProvider } from "@/lib/contexts/loading-context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5000,
      refetchOnWindowFocus: false,
    },
  },
});

export function Providers({ children }: PropsWithChildren<{}>) {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadingProvider>
        <ThemeProvider>
          <AuthProvider>
            <DemoModeProvider>
              <FeatureFlagProvider>
                <MockDataProvider>
                  <WebSocketProvider>
                    <FloorSelectionProvider>
                      <SmplrProvider>
                        <FloorplanDeviceStateProvider>
                          <DaylightUnitProvider>
                          <SidebarProvider>
                            <LayoutProvider>
                              <ModalProvider> {/* ✅ Added ModalProvider here */}
                                {/* <ClientBootstrap> */}
                                <SessionManager />
                                {/* ✅ ToastContainer added globally here */}
                                <ToastContainer
                                  position="top-right"
                                  autoClose={3000}
                                  hideProgressBar={false}
                                  newestOnTop
                                  closeOnClick
                                  pauseOnHover
                                  draggable
                                  theme="colored"
                                />
                                {children}
                                {/* </ClientBootstrap> */}
                              </ModalProvider>
                            </LayoutProvider>
                          </SidebarProvider>
                          </DaylightUnitProvider>
                        </FloorplanDeviceStateProvider>
                      </SmplrProvider>
                    </FloorSelectionProvider>
                  </WebSocketProvider>
                </MockDataProvider>
              </FeatureFlagProvider>
            </DemoModeProvider>
          </AuthProvider>
        </ThemeProvider>
      </LoadingProvider>
    </QueryClientProvider >
  );
}
